import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { api } from "../../api/apiClient";

import "../../css/layout.css";
import "../../css/cards.css";
import "../../css/forms.css";
import "../../css/buttons.css";

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const SetPasswordPage = () => {
  const query = useQuery();
  const history = useHistory();

  const userId = query.get("userId");
  const token = query.get("token");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    setError("");

    if (!userId || !token) {
      setError("Invalid or expired password link.");
      return;
    }

    if (!password || !confirmPassword) {
      setError("Please enter and confirm your password.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);

    try {
      await api<void>("/api/auth/set-password", {
        method: "POST",
        body: {
          userId,
          token,
          newPassword: password,
        },
      });

      setSuccess(true);

      setTimeout(() => {
        history.push("/login");
      }, 2500);
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Failed to set password. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <div className="card">
        <div className="card-header">
          <div className="card-title">Set Password</div>
        </div>

        {success ? (
          <div style={{ textAlign: "center", padding: "10px 0" }}>
            <p>Password set successfully.</p>
            <p>You can now sign in.</p>
            <p>Redirecting to login...</p>
          </div>
        ) : (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>New Password</label>

                <div className="password-input-wrapper">
                  <input
                    className="form-input"
                    type={showPassword ? "text" : "password"}
                    placeholder="New password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                  />

                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                  >
                    {showPassword ? (
                      <VisibilityOffIcon className="icon-green" />
                    ) : (
                      <VisibilityIcon className="icon-green" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Confirm Password</label>

                <div className="password-input-wrapper">
                  <input
                    className="form-input"
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    autoComplete="new-password"
                  />

                  <button
                    type="button"
                    className="toggle-password-btn"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    aria-label={
                      showConfirmPassword ? "Hide password" : "Show password"
                    }
                  >
                    {showConfirmPassword ? (
                      <VisibilityOffIcon className="icon-green" />
                    ) : (
                      <VisibilityIcon className="icon-green" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="button-row button-row-left">
                <button
                  className="form-submit-button"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  {loading ? "Setting Password..." : "Set Password"}
                </button>
              </div>
            </div>

            {error && <p className="error">{error}</p>}
          </>
        )}
      </div>
    </div>
  );
};

export default SetPasswordPage;
